import { jwtDecode } from 'jwt-decode';

/**
 * 验证JWT令牌是否有效（未过期、格式正确）
 * @param {string} token - JWT令牌
 * @returns {boolean} 令牌是否有效
 */
export function isTokenValid(token) {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    // 比较过期时间（decoded.exp为秒级时间戳，需转成毫秒与当前时间比较）
    return decoded.exp > Date.now() / 1000;
  } catch (error) {
    // 解析失败（如令牌格式错误），视为无效
    return false;
  }
}

/**
 * 从令牌中解析用户信息
 * @param {string} token - JWT令牌
 * @returns {object|null} 用户信息（含userId、username等）
 */
export function getTokenUserInfo(token) {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (error) {
    return null;
  }
}